<div
  [class]="fullWidth() ? '' : 'page-section page-section-x-padded'"
  class="curated-color-palette w-full flex flex-column gap-5">
  @if (isTitlesPresent()) {
    <div
      class="flex flex-column gap-3"
      [class.align-items-center]="isTextCenter()"
      [class.text-center]="isTextCenter()">
      @if (headline()) {
        <h2 class="headline p-0 m-0">
          {{ headline() }}
        </h2>
      }
      @if (subheadline()) {
        <h3 class="subheadline p-0 m-0">
          {{ subheadline() }}
        </h3>
      }
      @if (description()) {
        <h5 class="description p-0 m-0">
          {{ description() }}
        </h5>
      }
    </div>
  }

  <div class="colors-grid-container w-full mx-auto">
    <ppg-colors-grid [colors]="colors()" [rows]="colors().length" [gridItemStyleClass]="gridStyles">
      <ng-template pTemplate="emptyMessageTemplate"></ng-template>
    </ppg-colors-grid>
  </div>
</div>
